/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './live-video-right-rail-channels.stache';
import FeedService from 'scripts/services/base-feed-service';
import dtm from 'scripts/services/dtm';
import can from 'can';
import _ from 'lodash';

const channelsUrl = window.globalSettings.feeds.videos.liveScheduleUrl;

Component.extend({
    tag: 'video-right-rail-channels',
    template: template,
    leakScope: false,
    viewModel: {
        initLoad: true,
        define: {
            cards: {
                Type: can.List,
                Value: can.List,
            },
            streamOffMessagingConfig: {
                Type: can.Map,
                Value: can.Map,
            },
            activeChannels: {
                Type: can.List,
                Value: can.List,
            },
            activeView: {
                type: 'object',
                value: null,
            },
            adSizes: {
                Type: can.Map,
                get() {
                    return { width: 300, height: 150 };
                },
            },
            products: {
                Type: can.Map,
                Value: null,
            },
            productsCtaLink: {
                Type: can.Map,
                Value: null,
            },
        },
    },
    events: {
        inserted() {
            new FeedService({
                feedUrl: channelsUrl,
                fromCache: false,
                autoUpdate: true,
            })
                .on('data', (type, data) => {
                    this.viewModel.attr(
                        'streamOffMessagingConfig',
                        data.streamOffMessaging,
                    );

                    let cards = data.cards || [];

                    // TODO: Create live video feed service and make filtration there
                    cards = cards.filter((card) => {
                        if (card.channelIdentifier === 'audio') {
                            return false;
                        }

                        return true;
                    });

                    let refresh = this.compareCards(cards);
                    if (refresh) {
                        this.updateCards(cards);
                    }

                    this.viewModel.dispatch('dataLoaded');
                })
                .on('error', (error) => {
                    console.error('Error fetching live channels', error);
                })
                .fetch();
        },
        compareCards: function(newCards) {
            return this.cardsToCompare && this.cardsToCompare.length
                ? !_.isEqual(this.cardsToCompare, newCards)
                : true;
        },
        updateCards: function(cards) {
            this.cardsToCompare = _.cloneDeep(cards);
            let initLoad = this.viewModel.attr('initLoad'),
                liveCards = _.map(cards || [], (card) => {
                    if (card) {
                        card.channel = parseInt(
                            _.get(card, 'identifier', '').replace(
                                'channel',
                                '',
                            ),
                        );

                        if (isNaN(card.channel)) {
                            console.error(
                                `Wrong channel ${
                                    card.channel
                                } for video ${_.get(card, 'video.identifier')}`,
                            );
                            return null;
                        }
                    }

                    return card;
                }).filter((card) => {
                    return card && card.streamState === 'live';
                });

            this.viewModel.attr('cards', cards);
            this.viewModel.attr('liveCards', liveCards);

            if (initLoad) {
                this.viewModel.attr('initLoad', false);
            }
        },

        '{scope} streamOffMessagingConfig'(
            scope,
            event,
            streamOffMessagingConfig,
        ) {
            if (
                streamOffMessagingConfig &&
                !streamOffMessagingConfig.videoStreamingOn
            ) {
                this.viewModel.attr('activeChannels', []);
            }
        },

        'right-rail-channel click'(event, element) {
            dtm.trackLiveVideoLandingPage();
        },
    },
});
